import PropTypes from 'prop-types'
import React, { useCallback, useState } from 'react'
import { confirmAlert } from 'react-confirm-alert'
import { toast } from 'react-toastify'
import clinicalCarePriorities from '@/services/api/clinicalCarePriorities'
import FormPriority from '../Form'

function Row({ priority, fetchData, onPriorityRemoved }) {
  const [removing, setRemoving] = useState(false)

  const onRemove = useCallback(async () => {
    try {
      setRemoving(true)
      await clinicalCarePriorities.destroy(priority.id)
      setRemoving(false)
      toast.success('Prioridade excluída com sucesso')
      onPriorityRemoved(priority)
    } catch (e) {
      toast.error(e.message)
      setRemoving(false)
    }
  }, [onPriorityRemoved, priority])

  function onClickRemove() {
    confirmAlert({
      title: 'Excluir prioridade',
      message: 'Você está certo que deseja excluir esta prioridade?',
      buttons: [
        { label: 'Não' },
        {
          label: 'Sim',
          className: 'bg-error',
          onClick: onRemove,
        },
      ],
    })
  }

  return (
    <>
      <tr>
        <td>
          <div
            style={{
              backgroundColor: priority.color,
              borderRadius: '5px',
              padding: '5px',
              color: '#fff',
              width: '80px',
              textAlign: 'center',
            }}
          >
            {priority.color}
          </div>
        </td>
        <td>
          {priority.title}
          <div><small>{priority.description}</small></div>
        </td>
        <td>{priority.level}</td>
        <td className="text-right">
          <FormPriority
            priority={priority}
            btnClass="btn btn-primary btn-sm btn-action"
            btnIcon="fas fa-cog"
            onApiResponse={fetchData}
          />
          <button
            type="button"
            onClick={onClickRemove}
            className={`btn btn-sm btn-error btn-action ml-1 ${removing ? 'loading' : ''}`}
            title="Excluir"
            disabled={removing}
          >
            <i className="fas fa-trash" />
          </button>
        </td>
      </tr>
    </>
  )
}

Row.propTypes = {
  fetchData: PropTypes.func.isRequired,
  onPriorityRemoved: PropTypes.func.isRequired,
  priority: PropTypes.shape({
    id: PropTypes.number,
    title: PropTypes.string,
    description: PropTypes.string,
    color: PropTypes.string,
    level: PropTypes.number,
    createdAt: PropTypes.string,
  }).isRequired,
}

export default Row
